import { MainTheme } from './MainTheme'

export const DefaultTheme = MainTheme
